import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { USER_TYPE } from "../constants/common";
import useAuth from "../hooks/useAuth";
import { getLanguage } from "../utils/getLanguage";

const PrivateRoutes = ({ allowedRoles }) => {
  const user = useAuth();
  const lang = getLanguage();
  const location = useLocation();

  if (!user.role) {
    return <Navigate to={`${lang}/login`} state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // If the user's role isn't in the allowedRoles array, redirect them to their dashboard
    switch (user.role) {
      case USER_TYPE.STUDENT.ROLE:
        return <Navigate to={`/${lang}/${USER_TYPE.STUDENT.ROLE}`} replace />;
      case USER_TYPE.TEACHER.ROLE:
        return <Navigate to={`/${lang}/${USER_TYPE.TEACHER.ROLE}`} replace />;
      case USER_TYPE.SCHOOL.ROLE:
        return <Navigate to={`/${lang}/${USER_TYPE.SCHOOL.ROLE}`} replace />;
      default:
        return <Navigate to={`${lang}/login`} replace />;
    }
  }

  return <Outlet />;
};

export default PrivateRoutes;
